import React, { createContext, useContext, useState } from 'react';
import { isProductionEnvironment } from '../../utils/utils';

interface EnvironmentContextValue {
    hideInProduction: boolean;
    setHideInProduction: React.Dispatch<React.SetStateAction<boolean>>;
}

const EnvironmentContext = createContext<EnvironmentContextValue | undefined>(undefined);

interface EnvironmentProviderProps {
    children: React.ReactNode;
}

export const EnvironmentProvider: React.FC<EnvironmentProviderProps> = ({ children }) => {
    const [hideInProduction, setHideInProduction] = useState(isProductionEnvironment());

    return (
        <EnvironmentContext.Provider value={{ hideInProduction, setHideInProduction }}>
            {children}
        </EnvironmentContext.Provider>
    );
};

export const useEnvironmentData = () => {
    const value = useContext(EnvironmentContext);
    if (value === undefined) {
        throw new Error();
    }
    return value;
};
